package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.info.InfoPageScaffold
import com.arena_web.ui.sections.info.InfoParagraph
import com.arena_web.ui.theme.AppTypography
import com.arena_web.ui.utils.isMobile
import com.arena_web.ui.utils.mFontSize
import com.arena_web.ui.utils.mLetterSpacing
import com.arena_web.ui.utils.mLineHeight
import com.arena_web.ui.utils.sFontSize
import com.arena_web.ui.utils.sLetterSpacing
import com.arena_web.ui.utils.sLineHeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText

@Page("/about")
@Composable
fun AboutPage() {
    PageLayout(
        title = "About",
        description = "Arena is a global sports community designed to bring together people who love sports, making any game accessible to everyone, everywhere.",
        mobileReady = true,
    ) {
        InfoPageScaffold(title = "About Arena") {
            AboutLead("Find your players, your team, and your game.")
            InfoParagraph(
                "Arena is a global sports community designed to bring together people who love sports, making any " +
                    "game accessible to everyone, everywhere."
            )
            InfoParagraph(
                "The concept behind the platform is to create the most convenient and intuitive platform possible, " +
                    "where playing your favorite sport doesn't require endless searches for a sparring partner. In " +
                    "the past, finding a partner for a sports game used to take a lot of time. It required visiting " +
                    "dozens of specialized groups on various social media platforms, reviewing profiles, and " +
                    "enduring the awkwardness of chatting with strangers."
            )
            InfoParagraph(
                "The Arena online platform was created to change that. The founder's main goal is to bring all the " +
                    "necessary information together in one place and make it quick and easy for people to connect " +
                    "specifically for the purpose of playing together. You no longer need to search for like-minded " +
                    "people in various chat rooms. Here, your \"match\" happens automatically based on shared " +
                    "interests and a passion for specific sports. Whether you want to find someone for a one-on-one " +
                    "match or just play a friendly game on the weekend, Arena will make your favorite game as " +
                    "comfortable and productive as possible."
            )
            InfoParagraph(
                "Arena brings the concept of convenient and fun sports competitions to life, completely transforming " +
                    "the way people come together to play their favorite games. We've created a space where you can " +
                    "instantly find people to play sports with — whether you're looking for a partner or want to " +
                    "assemble your own team. The platform makes it easy to find like-minded people, create sports " +
                    "teams, and conveniently manage the entire process from one place. From simple friendly " +
                    "get-togethers to large team games, Arena helps everyone play for fun."
            )
            AboutLead("Your vibe and your crew. Your perfect game starts here.")
        }
    }
}

@Composable
private fun AboutLead(text: String) {
    if (isMobile()) {
        SpanText(
            text,
            modifier = Modifier
                .mFontSize(26)
                .mLineHeight(30)
                .mLetterSpacing(1)
                .fontWeight(AppTypography.SemiBold)
                .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)
                .styleModifier { property("color", "#FFFFFF") }
        )
        return
    }
    SpanText(
        text,
        modifier = Modifier
            .sFontSize(26)
            .sLineHeight(34)
            .sLetterSpacing(0.4)
            .fontWeight(AppTypography.SemiBold)
            .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)
            .styleModifier { property("color", "#FFFFFF") }
    )
}
